/** Custom "WAIVER" stamp icon — document + signing hand + tilted red WAIVER stamp overlay.
 * Renders crisp from 20px up. Reused across Escape Room + Haunted House flows. */
export default function WaiverStampIcon({ size = 34, stampColor = '#dc2626' }) {
  // Unique filter id per instance so multiple icons don't share the same grunge seed
  const fid = `wv-grunge-${size}-${stampColor.replace('#', '')}`;
  return (
    <svg
      width={size} height={size} viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
      style={{ filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.6))' }}
    >
      <defs>
        <filter id={fid} x="-15%" y="-15%" width="130%" height="130%">
          <feTurbulence type="fractalNoise" baseFrequency="1.6" numOctaves="1" seed="7" />
          <feDisplacementMap in="SourceGraphic" scale="1.4" />
        </filter>
      </defs>

      {/* Document */}
      <rect x="8" y="5" width="28" height="36" rx="2.5"
        fill="#fef9e7" stroke="#0f0f0f" strokeWidth="2" />
      <line x1="12" y1="11" x2="32" y2="11" stroke="#0f0f0f" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="12" y1="15" x2="29" y2="15" stroke="#0f0f0f" strokeWidth="1.8" strokeLinecap="round" />
      <line x1="12" y1="19" x2="31" y2="19" stroke="#0f0f0f" strokeWidth="1.8" strokeLinecap="round" />

      {/* Tilted stamp overlay */}
      <g transform="translate(24 27) rotate(-14)" filter={`url(#${fid})`}>
        <rect x="-21" y="-8" width="42" height="16" rx="0.6"
          fill="none" stroke={stampColor} strokeWidth="2.4" />
        <rect x="-18.5" y="-5.5" width="37" height="11" rx="0.3"
          fill="none" stroke={stampColor} strokeWidth="0.9" />
        <text x="0" y="3.5" textAnchor="middle" fontSize="10.5" fontWeight="900"
          fontFamily="Impact, 'Arial Black', sans-serif"
          fill={stampColor} letterSpacing="0.4"
          style={{ paintOrder: 'stroke', stroke: stampColor, strokeWidth: 0.4 }}>WAIVER</text>
      </g>

      {/* Pointing hand + cuff */}
      <g transform="translate(30 36)">
        <rect x="-2" y="4.5" width="10" height="2.5" rx="0.6" fill="#0f0f0f" />
        <path d="M-1 -1 L4 -4 L6 -2 L2 1 L2 4 L-2 4 Z"
          fill="#fef9e7" stroke="#0f0f0f" strokeWidth="1.4" strokeLinejoin="round" />
      </g>
    </svg>
  );
}
